import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-475a30ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border container-table bg-white" }
const _hoisted_2 = { class: "row-table-" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 5 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "me-2"
}
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = {
  key: 1,
  class: "d-flex align-center mt-8 border-t pt-3"
}
const _hoisted_11 = {
  key: 0,
  class: "w-100 px-4"
}

import { IHeadersTable } from '@/types';
import { withDefaults, ref, watch, onMounted, computed } from 'vue';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import { VueGoodTable } from 'vue-good-table-next';

import { MoleculeFilters, MoleculePagination, MoleculeTooltipMetas } from '@/components/molecules';
import {
  AtomBadge,
  AtomPhasedProgress,
  AtomInput,
  AtomInputMoney,
  AtomSelect,
  AtomAvatarOverlay,
  LoaderIcon,
  ChevronSolidIcon
} from '../atoms';

interface IProps {
  headers: Array<IHeadersTable>;
  items: any[];
  filters?: boolean;
  enableOptions?: boolean;
  disableSelectInfo?: boolean;
  selectOnCheckboxOnly?: boolean;
  textEmpty?: string;
  selectedClass?: string;
  indexSelect?: number;
  perPage?: number;
  page?: number;
  totalItems?: number;
  update?: boolean;
  pagination?: boolean;
  loading?: boolean;
  itemSelect?: any;
  hasOptions?: boolean;
  isFinanceira?: boolean;
  // checkbox?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTableAccordion',
  props: {
    headers: {},
    items: {},
    filters: { type: Boolean, default: false },
    enableOptions: { type: Boolean },
    disableSelectInfo: { type: Boolean },
    selectOnCheckboxOnly: { type: Boolean },
    textEmpty: { default: 'Sem informações para exibição' },
    selectedClass: { default: '' },
    indexSelect: {},
    perPage: { default: 10 },
    page: { default: 1 },
    totalItems: { default: 0 },
    update: { type: Boolean, default: false },
    pagination: { type: Boolean, default: true },
    loading: { type: Boolean },
    itemSelect: {},
    hasOptions: { type: Boolean, default: true },
    isFinanceira: { type: Boolean }
  },
  emits: [
  'handleUpload',
  'rowClick',
  'changePerPage',
  'changePage',
  'updateRow',
  'searching',
  'handleSort',
  'blur'
],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const table = ref(null);
const lengthItems = computed(() => {
  return Math.ceil(props.totalItems / perPageTable.value)
});
const search = ref<string>('');
const props = __props;

const updateValues = ref<any>({});
const page = ref(1);
const perPageTable = ref(10);
// let badges = props.headers.filter((f) => f.type == 'badge');

let pagination = {
  enabled: true,
  mode: 'records',
  perPage: perPageTable.value,
};

const computedItems = computed(() => {
  return props.items.filter(x => x.archived ? x.archived === 0 : true)
})

onMounted(() => {
  page.value = props.page;
  perPageTable.value = props.perPage;

  if (props.itemSelect) {
    props.headers
      .filter((f) => !!f.update)
      .map((x) => {
        updateValues.value[String(x.update)] = props.itemSelect[String(x.update)];
      });
  }
});
watch(
  () => page.value,
  () => {
    emit('changePage', page.value);
  }
);
watch(
  () => props.page,
  () => {
    page.value = props.page;
  }
);
watch(
  () => perPageTable.value,
  () => {
    emit('changePerPage', perPageTable.value);
  }
);
watch(
  () => props.perPage,
  () => {
    perPageTable.value = props.perPage;
  }
);
watch(
  () => updateValues.value,
  () => {
    emit('updateRow', updateValues.value);
  },
  { deep: true }
);

watch(
  () => search.value,
  () => {
    emit('searching', search.value);
  }
);

function onSortChange(params) {
  emit('handleSort', {
    type: params[0].type,
    field: params[0].field,
  });
}

watch(
  () => props.itemSelect,
  () => {
    if (props.itemSelect) {
      updateValues.value = {};

      const data: any = {};

      props.headers
        .filter((f) => !!f.update)
        .map((x) => {
          data[String(x.update)] = props.itemSelect[String(x.update)];
        });
      updateValues.value = data;
    }
  }
);

function handleBlur(event) {
  emit('blur', event)
}

function rowStyleClassFn(row)
{
  let clss = `${(row.due_date ? (new Date() > new Date(row.due_date) ? 'background-red' : '') : '')} ${(props.items[0].id == row.id ? 'v-step-row-modal-tutorial' : '')}`;

  return clss;
}

function validLine(row) {
  return props.indexSelect && row.id == props.indexSelect;
}
function handleUpload() {
  emit('handleUpload');
}
function onRowClick(params) {
  console.log(params);
}
function selectionChanged(params) {
  console.log('selected row', params);
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.filters)
      ? (_openBlock(), _createBlock(_unref(MoleculeFilters), {
          key: 0,
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          "has-search": "",
          onHandleUpload: handleUpload,
          onHandleBlur: handleBlur,
          "has-options": props.hasOptions
        }, {
          areaFilter: _withCtx(() => [
            _renderSlot(_ctx.$slots, "areaFilter")
          ]),
          _: 3
        }, 8, ["modelValue", "has-options"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(VueGoodTable), {
      isLoading: props.loading,
      ref_key: "table",
      ref: table,
      onSortChange: onSortChange,
      "select-options": {
      enabled: _ctx.enableOptions,
      selectOnCheckboxOnly: _ctx.selectOnCheckboxOnly,
      disableSelectInfo: _ctx.disableSelectInfo,
    },
      "enable-row-expand": true,
      onOnSelectedRowsChange: selectionChanged,
      styleClass: "vgt-table table-hover",
      "row-style-class": rowStyleClassFn,
      onRowClick: onRowClick,
      columns: _ctx.headers,
      rows: computedItems.value
    }, _createSlots({
      "row-details": _withCtx((props) => [
        _renderSlot(_ctx.$slots, "bodyCollapse", {
          row: props.row
        })
      ]),
      loadingContent: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(LoaderIcon)), { class: "ma-auto w-100" }))
      ]),
      "table-row": _withCtx((props) => [
        _createElementVNode("div", _hoisted_2, [
          (props.column.type == 'badge')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                (_ctx.update && !!props.column.mode && validLine(props.row))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (props.column.mode == 'money')
                        ? (_openBlock(), _createBlock(_unref(AtomInputMoney), {
                            key: 0,
                            modelValue: updateValues.value[props.column.update],
                            "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true),
                      (props.column.mode == 'date')
                        ? (_openBlock(), _createBlock(_unref(AtomInput), {
                            key: 1,
                            type: "date",
                            modelValue: updateValues.value[props.column.update],
                            "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true),
                      (props.column.mode == 'input')
                        ? (_openBlock(), _createBlock(_unref(AtomInput), {
                            key: 2,
                            modelValue: updateValues.value[props.column.update],
                            "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true),
                      (props.column.mode == 'select')
                        ? (_openBlock(), _createBlock(_unref(AtomSelect), {
                            key: 3,
                            width: "154px",
                            modelValue: updateValues.value[props.column.update],
                            "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                            options: props.column.options
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock(_unref(AtomBadge), {
                      key: 1,
                      text: props.formattedRow[props.column.field],
                      color: props.row.color,
                      "bg-color": props.row.bgColor
                    }, null, 8, ["text", "color", "bg-color"]))
              ]))
            : (props.column.type == 'overlay')
              ? (_openBlock(), _createBlock(_unref(AtomAvatarOverlay), {
                  key: 1,
                  images: props.formattedRow[props.column.field] ?? []
                }, null, 8, ["images"]))
              : (props.column.type == 'progress')
                ? (_openBlock(), _createBlock(_unref(AtomPhasedProgress), {
                    key: 2,
                    values: props.formattedRow[props.column.field]
                  }, null, 8, ["values"]))
                : (props.column.type == 'hint')
                  ? (_openBlock(), _createBlock(_unref(MoleculeTooltipMetas), {
                      key: 3,
                      items: [],
                      "items-only": props.formattedRow[props.column.field],
                      class: "text-center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Exibir ")
                      ]),
                      _: 2
                    }, 1032, ["items-only"]))
                  : (props.column.field == 'actions')
                    ? _renderSlot(_ctx.$slots, "actions", _mergeProps({ key: 4 }, _ctx.$attrs, { props: props }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                        (_ctx.update && !!props.column.mode && validLine(props.row))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              (props.column.mode == 'money')
                                ? (_openBlock(), _createBlock(_unref(AtomInputMoney), {
                                    key: 0,
                                    label: props.column.label,
                                    prependIcon: "",
                                    modelValue: updateValues.value[props.column.update],
                                    "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                                  }, {
                                    prependIcon: _withCtx(() => [
                                      _createTextVNode(" R$ ")
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "modelValue", "onUpdate:modelValue"]))
                                : _createCommentVNode("", true),
                              (props.column.mode == 'date')
                                ? (_openBlock(), _createBlock(_unref(AtomInput), {
                                    key: 1,
                                    type: "date",
                                    modelValue: updateValues.value[props.column.update],
                                    "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                                    label: props.column.label
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                : _createCommentVNode("", true),
                              (props.column.mode == 'input')
                                ? (_openBlock(), _createBlock(_unref(AtomInput), {
                                    key: 2,
                                    modelValue: updateValues.value[props.column.update],
                                    "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                                    label: props.column.label
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                : _createCommentVNode("", true),
                              (props.column.mode == 'select')
                                ? (_openBlock(), _createBlock(_unref(AtomSelect), {
                                    key: 3,
                                    width: "154px",
                                    label: props.column.label,
                                    modelValue: updateValues.value[props.column.update],
                                    "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                                    options: props.column.options
                                  }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "options"]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                              (props.column.extra && props.column.extra.avatar)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                    _createVNode(_component_v_avatar, {
                                      rounded: 8,
                                      color: "grey",
                                      size: "48"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_img, {
                                          cover: "",
                                          src: props.row['avatar']
                                        }, null, 8, ["src"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]))
                                : _createCommentVNode("", true),
                              (props.column.field == 'id')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (props.column.expander)
                                      ? (_openBlock(), _createBlock(_unref(ChevronSolidIcon), {
                                          key: 0,
                                          class: "rotate-invert"
                                        }))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass(props.column.maxLines ? 'overflow-text-table' : '')
                                  }, _toDisplayString(props.formattedRow[props.column.field]), 3)),
                              (props.column.maxLines)
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 3,
                                    activator: "parent",
                                    location: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(props.formattedRow[props.column.field]), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]))
                      ])),
          (props.column.extra && !props.column.extra.avatar)
            ? (_openBlock(), _createElementBlock("div", {
                key: 6,
                class: _normalizeClass(props.column.classExtra)
              }, _toDisplayString(props.row[props.column.fieldExtra]), 3))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (!!_ctx.textEmpty)
        ? {
            name: "emptystate",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.textEmpty), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["isLoading", "select-options", "columns", "rows"]),
    (props.pagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (props.totalItems != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_unref(MoleculePagination), {
                  class: "pagination-component",
                  modelValue: page.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((page).value = $event)),
                  numberOfPages: lengthItems.value,
                  "options-per-page": [10, 15, 20],
                  "total-items": props.totalItems,
                  perPage: perPageTable.value,
                  onChangePerPage: _cache[2] || (_cache[2] = ($event: any) => (perPageTable.value = $event))
                }, null, 8, ["modelValue", "numberOfPages", "total-items", "perPage"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})